const editTypes = {
  floating: 'floating',
  flyout: 'flyout',
  inline: 'inline',
  webcontrol: 'webcontrol'
} as const;

type EditType = keyof typeof editTypes;

interface OnPageEditingProps {
  'data-epi-property-name': string;
  'data-epi-use-mvc': 'True';
  'data-epi-property-edittype': string;
}

const getOnPageEditingProps = (
  propertyName?: string | null,
  editType?: EditType
): Partial<OnPageEditingProps> | Record<string, never> => {
  if (!propertyName) {
    return {};
  }

  return {
    'data-epi-property-name': propertyName,
    'data-epi-use-mvc': 'True',
    'data-epi-property-edittype': editType ? editTypes[editType] : undefined
  } as OnPageEditingProps;
};

getOnPageEditingProps.editTypes = editTypes;

export default getOnPageEditingProps;
